/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from "react";
import TextInput, { TextInputType } from "../text-input/text-input";
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import { useController, useFormContext, UseControllerReturn, FieldValues } from "react-hook-form";
const PlacesInput = PlacesInputController((props: PlacesInputType) => {
  const APIKEY = process.env.REACT_APP_MAP_KEY;
  const { placesService, placePredictions, getPlacePredictions } = usePlacesService({
    apiKey: APIKEY,
  });
  const [val, setval] = useState("");
  const [places, setPlaces] = useState([]);
  useEffect(() => {
    if (props?.value?.adresse){
      setval(props.value?.adresse|| "");
      props.controller?.field?.onChange(props?.value);
    }
  }, [props.value]);
  async function onChange(value: any) {
    props.controller?.field?.onChange(undefined);
    setval(value);
    if (!value) {
      setPlaces([]);
      return;
    }
    try {
      await getPlacePredictions({ input: value, componentRestrictions: { country: "fr" } });
      const addresses: any = placePredictions;
      setPlaces(
        addresses.map((i: any) => {
          return { label: i.description, value: i.place_id };
        })
      );
      if (props.onData) props.onData(addresses);
      if (props.onChange) props.onChange(value);
    } catch (e) {
      if (props.onData) props.onData([]);
    }
  }

  async function onSelectItem(item: any) {
    try {
      const placeId = item.value;
      placesService?.getDetails(
        {
          placeId: placeId,
        },
        (place: any) => {
          const adress = {
            location:{type:"Point",coordinates:[place.geometry.location.lng(),place.geometry.location.lat()]},
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
            street: place.address_components.find((elt: any) => elt.types.indexOf("route") != -1)?.long_name,
            streetNumber: place.address_components.find((elt: any) => elt.types.indexOf("street_number") != -1)
              ?.long_name,
            pays: place.address_components.find((elt: any) => elt.types.indexOf("country") != -1)?.short_name,
            codePostal: place.address_components.find((elt: any) => elt.types.indexOf("postal_code") != -1)?.short_name,
            seuleVille: place.address_components.find((elt: any) => elt.types.indexOf("locality") != -1)?.short_name,
            administrative_area_level_1: place.address_components.find(
              (elt: any) => elt.types.indexOf("administrative_area_level_1") != -1
            )?.long_name,
            administrative_area_level_2: place.address_components.find(
              (elt: any) => elt.types.indexOf("administrative_area_level_2") != -1
            )?.long_name,
            adresse: place.formatted_address,
          };
          props.controller?.field?.onChange(adress);
          props.controller?.field?.onBlur();
          if (props.onChooseAddress) {
            props.onChooseAddress(adress);
          }
        }
      );
    } catch (e) {
      /* empty */
    }
  }
  const error = props.controller?.fieldState?.invalid;
  const errorMSg = props.controller?.fieldState?.error?.message;
  const success = props.controller?.fieldState?.isDirty && !error;
  return (
   <div className="placesinput">
    <TextInput
      onBlur={props.controller?.field?.onBlur}
      {...props}
      controller={undefined}
      name={undefined}
      onSelectItem={onSelectItem}
      datalist={places}
      value={val}
      errorMsg={errorMSg}
      className={`${error ? "form-control-invalid" : ""} ${success ? "form-control-valid" : ""}`}
      onChange={onChange}
    />
    </div> 
  );
});
export default PlacesInput;
function PlacesInputController(Input: any) {
  return function (props: PlacesInputType) {
    return InputControl(Input, props);
  };
}
function InputControl(Input: any, p: PlacesInputType) {
  const formContext = useFormContext();
  let controller: any;
  if (p.name && formContext)
    // eslint-disable-next-line react-hooks/rules-of-hooks
    controller = useController({ 
      name: p.name,
      rules: {
        validate: (val: any) => {
          if (p.required) {
            return !isNaN(val?.lat) ? true : "Adresse invalide , sélectionner une adresse ";
          }
          return !val || !isNaN(val?.lat) ? true : "Adresse invalide ,sélectionner une adresse ";
        },
      },
      defaultValue: p?.value,
    });
  return <Input {...p} controller={controller} />;
}


interface PlacesInputType extends TextInputType {
  language?: string;
  countries?: string[];
  onData?: Function;
  controller?: UseControllerReturn<FieldValues, string>;
  onChooseAddress?: Function;
  showlocationBtn?: boolean;
  value?:any;
}
